import React from 'react';

function Spinner({isPage = false}: any) {
    return (
        <div className={`${isPage ? 'fixed min-h-dvh' : 'absolute'} top-0 left-0 z-10 w-full h-full max-h-dvh flex items-center justify-center`} style={{backgroundColor: 'rgba(0, 0, 0, 0.4)'}}>
            <div className="spinner"></div>
        </div>
    );
};

export default Spinner;
